import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyDSKNc1Qa1aP9GcvgLLtmb0jQ4Rk1f6ino',
  authDomain: 'appgate-wq1rx.firebaseapp.com',
  projectId: 'appgate-wq1rx',
  storageBucket: 'appgate-wq1rx.firebasestorage.app',
  messagingSenderId: '29045864220',
  appId: '1:29045864220:web:f3dafd4a0f01b9ca65ecd9',
};

const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
export const auth = getAuth(app);
